module.exports = __webpack_public_path__ + "img/w6_02.825323c2.jpg";